var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "工程编号",
                            prop: "proCode",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写工程编号" },
                            model: {
                              value: _vm.inputForm.proCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "proCode", $$v)
                              },
                              expression: "inputForm.proCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否配置完成",
                            prop: "isFinish",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写是否配置完成" },
                            model: {
                              value: _vm.inputForm.isFinish,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "isFinish", $$v)
                              },
                              expression: "inputForm.isFinish",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否需要材料配置",
                            prop: "isNeedMaterial",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写是否需要材料配置" },
                            model: {
                              value: _vm.inputForm.isNeedMaterial,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "isNeedMaterial", $$v)
                              },
                              expression: "inputForm.isNeedMaterial",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "工程类别",
                            prop: "kindId1",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写工程类别" },
                            model: {
                              value: _vm.inputForm.kindId1,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "kindId1", $$v)
                              },
                              expression: "inputForm.kindId1",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "工程类型",
                            prop: "kindId2",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写工程类型" },
                            model: {
                              value: _vm.inputForm.kindId2,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "kindId2", $$v)
                              },
                              expression: "inputForm.kindId2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "项目名称", prop: "name", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写项目名称" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "施工指示",
                            prop: "workPoint",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写施工指示" },
                            model: {
                              value: _vm.inputForm.workPoint,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "workPoint", $$v)
                              },
                              expression: "inputForm.workPoint",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "常规标准",
                            prop: "workStandard",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写常规标准" },
                            model: {
                              value: _vm.inputForm.workStandard,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "workStandard", $$v)
                              },
                              expression: "inputForm.workStandard",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "注意事项",
                            prop: "workNote",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写注意事项" },
                            model: {
                              value: _vm.inputForm.workNote,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "workNote", $$v)
                              },
                              expression: "inputForm.workNote",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "施工单位",
                            prop: "workUnitId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写施工单位" },
                            model: {
                              value: _vm.inputForm.workUnitId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "workUnitId", $$v)
                              },
                              expression: "inputForm.workUnitId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "单位信息id",
                            prop: "unitId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写单位信息id" },
                            model: {
                              value: _vm.inputForm.unitId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "unitId", $$v)
                              },
                              expression: "inputForm.unitId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "关联其他工程ID",
                            prop: "otherProjectId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写关联其他工程ID" },
                            model: {
                              value: _vm.inputForm.otherProjectId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "otherProjectId", $$v)
                              },
                              expression: "inputForm.otherProjectId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "关联其他必选工程项目编号",
                            prop: "otherRequireProjectIds",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写关联其他必选工程项目编号",
                            },
                            model: {
                              value: _vm.inputForm.otherRequireProjectIds,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.inputForm,
                                  "otherRequireProjectIds",
                                  $$v
                                )
                              },
                              expression: "inputForm.otherRequireProjectIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "图片", prop: "picture", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写图片" },
                            model: {
                              value: _vm.inputForm.picture,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "picture", $$v)
                              },
                              expression: "inputForm.picture",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "备注", prop: "remarks", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写备注" },
                            model: {
                              value: _vm.inputForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "remarks", $$v)
                              },
                              expression: "inputForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }